import * as React from 'react'
import { type IconProps } from './types'
/**
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB0PSIxNzIyOTMzOTc5NDMyIiBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHAtaWQ9Ijc5NTkiIHdpZHRoPSIyMDAiIGhlaWdodD0iMjAwIiBzdHlsZT0iYmFja2dyb3VuZDojZmZmIj48cGF0aCBkPSJNODY0IDcwNGEzMiAzMiAwIDAgMSAzMS40ODggMjYuMjRsMC41MTIgNS43NnY2NGE5NiA5NiAwIDAgMS04Ni43ODQgOTUuNTUyTDgwMCA4OTZoLTU3NmE5NiA5NiAwIDAgMS05NS41NTItODYuNzg0TDEyOCA4MDB2LTY0YTMyIDMyIDAgMCAxIDYzLjQ4OC01Ljc2TDE5MiA3MzZ2NjRhMzIgMzIgMCAwIDAgMjYuMjQgMzEuNDg4TDIyNCA4MzJoNTc2YTMyIDMyIDAgMCAwIDMxLjQ4OC0yNi4yNEw4MzIgODAwdi02NGEzMiAzMiAwIDAgMSAzMi0zMnpNNTEyIDY0YTMyIDMyIDAgMCAxIDMxLjQ4OCAyNi4yNGwwLjUxMiA1Ljc2djUzNi41NzZsMjM0Ljc1Mi0yMDguNTEyYTMyIDMyIDAgMCAxIDQ2LjQ2NCA0My42NDhsLTMuOTY4IDQuMjI0LTI4OCAyNTZhMzIgMzIgMCAwIDEtMzcuNjk2IDMuNTJsLTQuOC0zLjUyLTI4OC0yNTZhMzIgMzIgMCAwIDEgMzcuODg4LTUxLjI2NGw0LjYwOCAzLjM5Mkw0ODAgNjMyLjcwNFY5NkEzMiAzMiAwIDAgMSA1MTIgNjR6IiBwLWlkPSI3OTYwIj48L3BhdGg+PC9zdmc+)
 */
export const DownloadIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 15, ...props }, forwardedRef) => {
    return (
      <svg
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M864 704a32 32 0 0 1 31.488 26.24l0.512 5.76v64a96 96 0 0 1-86.784 95.552L800 896h-576a96 96 0 0 1-95.552-86.784L128 800v-64a32 32 0 0 1 63.488-5.76L192 736v64a32 32 0 0 0 26.24 31.488L224 832h576a32 32 0 0 0 31.488-26.24L832 800v-64a32 32 0 0 1 32-32zM512 64a32 32 0 0 1 31.488 26.24l0.512 5.76v536.576l234.752-208.512a32 32 0 0 1 46.464 43.648l-3.968 4.224-288 256a32 32 0 0 1-37.696 3.52l-4.8-3.52-288-256a32 32 0 0 1 37.888-51.264l4.608 3.392L480 632.704V96A32 32 0 0 1 512 64z"
          fill={color}
        ></path>
      </svg>
    )
  },
)
